import React from 'react';

export function SourceTypeColumnFormatter(cellContent) {
  const {sourceID, sourceName} = cellContent;
  switch (sourceID) {
    case 1:
      return (
        <div
          className="badge badge-pill w-125px font-size-h4 text-nowrap"
          style={{
            background: '#F9F4E5',
            border: '1px solid rgb(253, 185, 19)',
            color: 'rgb(253, 185, 19)'
          }}
        >
          {sourceName}
        </div>
      );
    case 2:
      return (
        <div
          className="badge badge-pill w-125px font-size-h4 text-nowrap"
          style={{
            background: '#E3F0FB',
            border: '1px solid rgb(56, 189, 248)',
            color: 'rgb(56, 189, 248)'
          }}
        >
          {sourceName}
        </div>
      );
    default:
      return null;
  }
}